module.exports = __webpack_public_path__ + "img/BOSdynamics2.b619cd51.jpg";